export default __webpack_public_path__ + "static/media/mascot.8b11d81f.png";